import React from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';

import Router from './routing/index';
import interceptors from './axios';

import { store } from './redux';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import Loader from './components/loader/loader';

function App() {
  interceptors.setupInterceptors();
  document.body.appendChild(Loader());

  return (
    <div className='light'>
      <DndProvider backend={HTML5Backend}>
        <Provider store={store}>
          <Router />
          <ToastContainer />
        </Provider>
      </DndProvider>
    </div>
  );
}

export default App;
